import React, {useEffect, useState} from "react";
import SelectField from "../SelectField";
import {useSelector} from "react-redux";
import {apiGetTurnstileTemplate} from "../../pages/ENIGOOTurnstiles/TurnstileTemplate/Actions";

const ApiTurnstileTemplateField = ({disabled = false, isMulti = true,onChange=null,isMandatory=false,onEnter=null, name="turnstileTemplate",label="Šablona turniketu",filterTypes=[]}) => {

    let [data, setData] = useState([]);
    let [loading, setLoading] = useState(false);
    let user = useSelector((state) => state.user)


    useEffect(() => {
        user.activeAreal && getData();
    }, [user.activeAreal])

    const getData = () => {
        setLoading(true);
        apiGetTurnstileTemplate(user.activeAreal.id, null, (data) => {
            if(filterTypes.length > 0){
                data = data.filter(item => filterTypes.includes(item.type))
            }
            setData(data);
            setLoading(false);
        }, (error) => {
            setData([]);
            setLoading(false);
        })
    }

    let options = React.useMemo(()=>{
        if(loading) return [];
        if(!data) return []
        return data?.map((item, index) => {
            return {label: item.name, value: item.id}
        })
    },[data])

    if (isMulti) {
        return (
            <SelectField onEnter={onEnter} isMandatory={isMandatory} disabled={disabled}
                         placeholder={loading ? "Načítám data.." : "Šablony turniketů"} name={name}
                         options={options} label={label} isMulti={true} onChange={onChange}/>
        )
    }else{
        return (
            <SelectField onEnter={onEnter} isMandatory={isMandatory} name={name} options={options}
                         label={label} isMulti={false} onChange={onChange}/>
        )
    }
}

export default ApiTurnstileTemplateField;
